import React from 'react';
import styled from 'styled-components';
import { colors } from '~/styles';
import Checkbox from '../Checkbox';
import InlineTooltip from '../InlineTooltip';
import ListViewCell from './ListViewCell';
import ListViewColumn from './ListViewColumn';

const S = {
  Checkbox: styled.div`
    > label > div {
      background: ${colors.white};
    }
  `,
};

function Column({ selection, tooltip, testId, ...props }) {
  return (
    <ListViewColumn sticky name="selector" width="3.5rem" align="center" {...props}>
      <S.Checkbox>
        <Checkbox
          data-testid={testId}
          disabled={props.disabled}
          checked={selection.any}
          partial={selection.some}
          onChange={selection.toggleAll}
        />
      </S.Checkbox>

      {tooltip ? <InlineTooltip message={tooltip} /> : null}
    </ListViewColumn>
  );
}

function RowCheckbox({ id, selection, testId }) {
  const handleClick = (e) => {
    // Firefox labels don't pass a Shift+click on to their input, so a Shift+click on the box toggles here.
    if (!e.shiftKey || e.target.tagName === 'INPUT') return;
    e.preventDefault();
    if (!selection.isDisabled(id)) selection.toggle(id, { range: true });
  };

  return (
    <S.Checkbox onClick={handleClick} onMouseDown={(e) => e.shiftKey && e.preventDefault()}>
      <Checkbox
        data-testid={testId}
        disabled={selection.isDisabled(id)}
        checked={selection.isSelected(id)}
        onChange={(e) => selection.toggle(id, { range: e.nativeEvent.shiftKey })}
      />
    </S.Checkbox>
  );
}

function Cell({ id, selection, testId, ...props }) {
  return (
    <ListViewCell onClick={(e) => e.stopPropagation()} {...props}>
      <RowCheckbox id={id} selection={selection} testId={testId} />

      {selection.isDisabled(id) ? (
        <InlineTooltip message={`You can only select ${selection.limit} items at a time.`} />
      ) : null}
    </ListViewCell>
  );
}

const ListViewSelection = {};
ListViewSelection.Column = Column;
ListViewSelection.Cell = Cell;
ListViewSelection.Checkbox = RowCheckbox;

export default ListViewSelection;
